import PaymentMethodError from './PaymentMethodError'
export default PaymentMethodError
